var div = null;
var prefixes = ['Webkit', 'Moz', 'O', 'ms'];

module.exports = function prefixStyle(prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div');
  }

  var style = div.style; // prop exists without prefix

  if (prop in style) {
    return prop;
  } // borderRadius -> BorderRadius


  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1); // find the vendor-prefixed prop

  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase; // e.g. WebkitBorderRadius or webkitBorderRadius

    if (name in style) {
      return name;
    }
  }

  return false;
};